export const INCLUDE_PARENTS = 'include_parents' as const

export const isPayerDataVisibleItems = () => [
  [
    {
      id: INCLUDE_PARENTS,
      title: 'Вывести данные плательщиков',
    },
  ],
  [],
]
